<template>
<section class="section activities">
    <div class="container">
        <header class="section-header">
            <h2 class="title is-2">{{section_data.title}}</h2>
            <span><i></i><i></i><i></i></span>
        </header>
        <div :class="['columns is-multiline is-variable is-4']">
            <div class="column is-4">
                <StravaActivity :g_key="section_data.g_key" :item="section_data.strava" />
            </div>
            <div class="column is-4">
                <ProjectActivity :item="section_data.project" :type="'Project'" />
            </div>
            <div class="column is-4">
                <ProjectActivity :item="section_data.news" :type="'News'" />
            </div>
        </div>
    </div>
</section>
</template>

<script>
import StravaActivity from '../elements/StravaActivity';
import ProjectActivity from '../elements/ProjectActivity';
import PosHandler from '../../mixins/PosHandler';
export default {
    name        :   'SectionActivities',
    props       :   ['section_data', 'is_mobile'],
    mixins      :   [ PosHandler ],
    components  :   { StravaActivity, ProjectActivity }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/sections/SectionActivities.vue